<template>
    <div class="bl-search">
      <div class="pane-header">
                    <h2>Search</h2>
                    <font-awesome-icon :icon="['fas', 'times']" size="sm" @click="closeIt"/>
                </div>
        <div class="controls">
            <input type="text" placeholder="Enter a keyword or zone"  class="form-control" id="txtSearch" 
              aria-describedby="search" v-model="searchTerm" :disabled="getRequestLoadStatus || getServiceStatus"
                          v-on:keyup.enter="searchThis" autocomplete="off"/>     
                          <button class="btn-search"  v-on:click="searchThis" :disabled="getRequestLoadStatus || getServiceStatus">
                            <span class="sr-only">Search</span>
                            <searchIcon/>
                          </button>
                           

          <p>For example, <i>garage</i> or <i>R5-1</i> or <i>4.6.2.1</i>. </p>                   
                       
        </div>
        <div class="pane-content" v-if="resultList && resultList.count > 0">
          <span><i>Found {{resultList.list.length}} results.</i></span>
         
          <a class="float-right" href="javascript:void(0)" @click="clearSearch"><u>Clear search</u></a>
          <button class="btn btn-secondary d-none" @click="openPrintPreview">Print result</button>
          <div :tabindex="0"  class="card border-shadow mb-2" v-for="bylaw in resultList.list" :key="bylaw.id"
           @click="referToBylaw(bylaw)" @keyup.enter.space="referToBylaw(bylaw)" >
            <div class="card-body" >               
                 {{bylaw.version}} {{bylaw.title}}
            </div>
          </div>
          <div class="mb-2 mt-3">
            <div class="card-body text-center" >               
               <hr/>
            </div>
          </div>
        </div>
        <div class="pane-content" v-if="resultList != null && resultList.count == 0">
          <span><i>No bylaw found.</i></span>
        </div>
    </div>
</template>

<script>
import searchIcon from "@/components/Svg/SearchIcon";
import closeIcon from "@/components/Svg/CloseIcon";
import { mapGetters, mapActions } from "vuex";
import VersionCompare from "@/components/Mixins/VersionComparer";
export default {
  name: "search",
  components: {searchIcon, closeIcon},
  data(){
    return{
      searchTerm:"",
      resultList:null,
      showSearch: false
    }
  },
  computed: {
    ...mapGetters("loader",["getRequestLoadStatus"]),
    ...mapGetters("search", ["getSearchTerm","getSearchResult", "getSearchStatus"]),
    ...mapGetters("viewer", ["getServiceStatus"])
  },
  methods:{
    ...mapActions("search", ["fetchBylawForKeyword"]),
    searchThis: function(){
      this.fetchBylawForKeyword(this.searchTerm);
    },
    referToBylaw: function(content){
      if(content.version != null){
        this.$router.push(`/searchbyversion/${content.version}`);
      } else {
        this.$router.push(`/definitions/${content.title}`);
      }
    },
    closeIt: function(){
      this.$emit("close");
    },
    openPrintPreview: function(){
      const ids = this.resultList.list.map(entity => entity.id);
      let routeData = this.$router.resolve({       
        path: "/search-print/"+ids+"?term="+this.searchTerm+"&count="+this.resultList.list.length
      });      
       window.open(routeData.href, "_blank", "width=1000&location=no&scrollBar=yes");
    },
    clearSearch: function(){
        this.searchTerm = "";
        this.showSearch = false;
        this.resultList = null;
    },
  },
   watch: {    
    getSearchResult: function (newvalue) {
      if(newvalue){
         this.resultList = this.getSearchResult;
         this.resultList.list = this.resultList.list.sort(function (a, b) {            
            return VersionCompare.Comparer(a.version, b.version);
          });
         this.showSearch = true;
      }
    }
  }
};
</script>